"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlogJsonLd = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _jsonld = require("./jsonld");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BlogJsonLd = function BlogJsonLd(_ref) {
  var url = _ref.url,
      headline = _ref.headline,
      title = _ref.title,
      _ref$images = _ref.images,
      images = _ref$images === void 0 ? [] : _ref$images,
      datePublished = _ref.datePublished,
      _ref$dateModified = _ref.dateModified,
      dateModified = _ref$dateModified === void 0 ? null : _ref$dateModified,
      authorName = _ref.authorName,
      _ref$authorType = _ref.authorType,
      authorType = _ref$authorType === void 0 ? 'Person' : _ref$authorType,
      keywords = _ref.keywords,
      description = _ref.description,
      publisherName = _ref.publisherName,
      publisherLogo = _ref.publisherLogo,
      _ref$posts = _ref.posts,
      posts = _ref$posts === void 0 ? [] : _ref$posts,
      issn = _ref.issn,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      _ref$defer = _ref.defer,
      defer = _ref$defer === void 0 ? false : _ref$defer;

  var json = _objectSpread({
    '@context': 'https://schema.org',
    '@type': 'Blog',
    mainEntityOfPage: {
      '@type': 'Blog',
      '@id': url
    },
    headline: headline !== null && headline !== void 0 ? headline : title,
    keywords: keywords,
    issn: issn,
    image: images,
    datePublished: datePublished,
    dateModified: dateModified !== null && dateModified !== void 0 ? dateModified : datePublished,
    description: description,
    author: authorName ? {
      '@type': authorType,
      name: authorName
    } : undefined,
    publisher: publisherName ? {
      '@type': 'Organization',
      name: publisherName,
      logo: publisherLogo ? {
        '@type': 'ImageObject',
        url: publisherLogo
      } : undefined
    } : undefined,
    blogPost: posts.map(function (post) {
      return _objectSpread({
        '@type': 'BlogPosting'
      }, post);
    })
  }, overrides);

  return /*#__PURE__*/_react["default"].createElement(_jsonld.JsonLd, {
    defer: defer,
    json: json
  });
};

exports.BlogJsonLd = BlogJsonLd;